import { getRuleConfig, getUnusedRuleList, RuleConfig as ImportedRuleConfig } from './ruleConfigs';
import { getRulesetConfig, RulesetConfig as ImportedRulesetConfig } from './rulesetConfigs';

export type RuleConfig = ImportedRuleConfig;
export type RulesetConfig = ImportedRulesetConfig;

export const Configs = {
  getRuleConfig,
  getUnusedRuleList,
  getRulesetConfig,
};
